<span
  class="sensitive-badge"
  [matTooltip]="'exportColumns.dialog.sensitiveTooltip' | translate"
  [matTooltipShowDelay]="200"
>
  {{ 'exportColumns.dialog.sensitiveBadge' | translate }}
</span>
